export enum DashboardPaymentType {
  Topup = 1,
  Withdraw = 2,
  CryptoWithdraw = 3,
}

export type TraderDashboardModel = {
  topup: {
    totalCount: number
    totalAmountFrom: number
    totalAmountTo: number
    paidCount: number
    paidAmountFrom: number
    paidAmountTo: number
    spamCount: number
    spamAmountFrom: number
    spamAmountTo: number
    paidMerchantsCount: number
    totalMerchantsCount: number
    averageConfirmSeconds: number
    commissionAmount: number
  }
  yesterdayTopup: {
    totalCount: number
    totalAmountFrom: number
    totalAmountTo: number
    paidCount: number
    paidAmountFrom: number
    paidAmountTo: number
    spamCount: number
    spamAmountFrom: number
    spamAmountTo: number
    paidMerchantsCount: number
    totalMerchantsCount: number
    averageConfirmSeconds: number
    commissionAmount: number
  }
  topupTotalRequisitLimit: {
    totalMaxDailyLimit: number
    count: number
  }
  withdraw: {
    totalCount: number
    totalAmountFrom: number
    totalAmountTo: number
    paidCount: number
    paidAmountFrom: number
    paidAmountTo: number
    paidAverageAmountFrom: number
    paidAverageAmountTo: number
    averageConfirmSeconds: number
    commissionAmount: number
  }
  disput: {
    totalCount: number
    amountFromMerchant: number
    amountFromMerchantUsdt: number
    amountFromTrader: number
    amountFromTraderUsdt: number
  }
  cryptoWithdrawAmount: number | null
  cryptoWithdrawSentAmount: number | null
  cryptoWithdrawCreatedAt: string | null
}
